import React, {useEffect, useState} from "react";
import {PhoneIcon, EmailIcon, UserIcon} from "../assets/icons";
import {notification, message} from "antd";
import AuthApi from "../api/AuthApi";
import RequestApi from "../api/RequestApi";
import axios from "axios";
import config from "../api/config";
import useAuth from "../hooks/useAuth";
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import Button from "../components/element/Button";
import { CreditCardOutlined, BankOutlined } from '@ant-design/icons';
import Input from "../components/element/Input";
import UserApi from "../api/UserApi";
import {EmailFunc} from "../func/StringFunc";

const PublicOrder = () => {

    const [apiNotification, contextHolder] = notification.useNotification();
    const {isAuthenticated, setAuth, setRoles, setUser} = useAuth();
    const navigate = useNavigate();
    const {id} = useParams();
    const [valueName, setValueName] = React.useState('');
    const [valueSurname, setValueSurname] = React.useState('');
    const [valueFatherName, setValueFatherName] = React.useState('');
    const [valueLogin, setValueLogin] = React.useState('+7 ');
    const [valueEmail, setValueEmail] = React.useState('');
    const [valueVerifyCode, setValueVerifyCode] = React.useState('');
    const [ isErrorName, setIsErrorName ] = React.useState(false);
    const [ isErrorSurname, setIsErrorSurname ] = React.useState(false);
    const [ isErrorFatherName, setIsErrorFatherName ] = React.useState(false);
    const [ isErrorLogin, setIsErrorLogin ] = React.useState(false);
    const [ isErrorEmail, setIsErrorEmail ] = React.useState(false);
    const [ isErrorVerifyCode, setIsErrorVerifyCode ] = React.useState(false);

    const [ isSendCode, setIsSendCode ] = React.useState(false);
    const [ isSelectPayment, setIsSelectPayment ] = React.useState(false);
    const [ isFormCompany, setIsFormCompany ] = React.useState(false);
    const [ isUserRegister, setIsUserRegister ] = React.useState(true);
    const [userId, setUserId] = React.useState(0);

    const [valueCompany, setValueCompany] = React.useState('');
    const [valueCompanyInn, setValueCompanyInn] = React.useState('');
    const [ isErrorCompany, setIsErrorCompany ] = React.useState(false);
    const [ isErrorCompanyInn, setIsErrorCompanyInn ] = React.useState(false);

    const [contentImage, setContentImage] = useState('');
    const [contentTitle, setContentTitle] = useState('');
    const [contentPrice, setContentPrice] = useState('');

    const handleChangeLogin = (event) => {

        let formatted = '';

        let numbersOnly = event.target?.value.replace(/\D/g, '');

        if (numbersOnly.length > 0) {
            formatted += '+7 ';
        }
        if (numbersOnly.length > 1) {
            formatted += '(' + numbersOnly.substring(1, 4);
        }
        if (numbersOnly.length > 4) {
            formatted += ') ' + numbersOnly.substring(4, 7);
        }
        if (numbersOnly.length > 7) {
            formatted += '-' + numbersOnly.substring(7, 9);
        }
        if (numbersOnly.length > 9) {
            formatted += '-' + numbersOnly.substring(9, 11);
        }

        setValueLogin(formatted);
    }

    const register = () => {

        let isError = false;

        setIsErrorName(false);
        setIsErrorSurname(false);
        setIsErrorFatherName(false);
        setIsErrorLogin(false);
        setIsErrorEmail(false);

        if (valueLogin === '' || valueLogin.length < 11) {
            isError = true;
            setIsErrorLogin(true);
        }

        if (valueName === '' ) {
            isError = true;
            setIsErrorName(true);
        }

        if (valueSurname === '' ) {
            isError = true;
            setIsErrorSurname(true);
        }

        if (valueFatherName === '' ) {
            isError = true;
            setIsErrorFatherName(true);
        }

        if (valueEmail === '' || !EmailFunc.isValid(valueEmail)) {
            isError = true;
            setIsErrorEmail(true);
        }

        if (!isError) {

            AuthApi.register(valueLogin, valueEmail, valueName, valueSurname, valueFatherName).then((data) => {
                if (data.status === 'success') {
                    setIsSendCode(true);
                    setUserId(data.content.id);
                } else {
                    setIsErrorLogin(true);
                }
            });

        } else {
            apiNotification['error']({
                message: 'Ошибка',
                description:
                    'Пожалуйста, заполните все обязательные поля отмеченные *',
            });
        }

    }

    const verify = () => {
        if (valueVerifyCode === '') {
            setIsErrorVerifyCode(true);
            apiNotification['error']({
                message: 'Ошибка',
                description:
                    'Пожалуйста, введите код из SMS или E-mail',
            });
        } else {
            AuthApi.verify(userId, valueVerifyCode).then((data) => {
                if (data.status === 'success' && data.content.token) {
                    localStorage.setItem('token', data.content.token);
                    setAuth(true);
                    let roles = ['ROLE_USER'];
                    if (data.content.roles) {
                        localStorage.setItem('roles', JSON.stringify(data.content.roles));
                        setRoles(data.content.roles);
                        let currentUser = {
                            id: data.content.id,
                            login: data.content.login,
                            name: data.content.name
                        }
                        localStorage.setItem('user', JSON.stringify(currentUser));
                        setUser(currentUser);
                    }
                    setIsSelectPayment(true);
                    setIsSendCode(false);
                    setIsUserRegister(true);
                } else {
                    setIsErrorVerifyCode(true);
                    apiNotification['error']({
                        message: 'Ошибка',
                        description:
                            'Код указан неверно. Пожалуйста, попробуйте еще раз',
                    });
                }
            });
        }
    }

    const onBuy = () => {
        RequestApi.post('order/create/product', {
            product_id: id
        }).then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                window.location.href = data.content.item.payment_url;
            } else if (data.error.messages.length > 0) {
                data.error.messages.forEach((error) => {
                    message.error(error);
                })
            }
        })

    }

    const onBuyInvoice = () => {

        let isError = false;

        setIsErrorCompany(false);
        setIsErrorCompanyInn(false);

        if (valueCompany === '' ) {
            isError = true;
            setIsErrorCompany(true);
        }

        if (valueCompanyInn === '' || valueCompanyInn.length < 10) {
            isError = true;
            setIsErrorCompanyInn(true);
        }

        if (!isError) {
            RequestApi.post('order/create/product', {
                product_id: id,
                payment: 'invoice',
                paymentCompany: valueCompany,
                paymentCompanyInn: valueCompanyInn,
            }).then((data) => {
                if (data.status === RequestApi.STATUS_SUCCESS) {
                    //window.location.href = data.content.item.payment_invoice;
                    window.open(data.content.item.payment_invoice, "_blank");
                    navigate('/cabinet/orders');
                } else if (data.error.messages.length > 0) {
                    data.error.messages.forEach((error) => {
                        message.error(error);
                    })
                }
            })
        } else {
            apiNotification['error']({
                message: 'Ошибка',
                description:
                    'Пожалуйста, заполните данные компании',
            });
        }

    }

    const onHandlerAuth = () => {
        if (isAuthenticated) {
            setIsSelectPayment(true);
            setIsUserRegister(true);
            onLoadUser();
        }
    }

    const onLoadUser = () => {
        UserApi.current().then((data) => {
            if (data.status === 'success' && data.content.item !== undefined) {
                setValueCompany(data.content.item.company);
                setValueCompanyInn(data.content.item.company_inn ? data.content.item.company_inn : '');
            }
        })
    }

    useEffect(() => {

        if (!localStorage.getItem('token')) {
            setIsUserRegister(false);
        }

        axios.get(config.host + '/api/course/' + id).then(({data}) => {
            if (data.content.item) {
                setContentImage(data.content.item.picture);
                setContentTitle('[Код: ' + data.content.item.code + '] ' + data.content.item.title);
                setContentPrice(data.content.item.price);
            } else {
                window.location = 'https://kmos-perm.com/distance-learning/';
            }
        })
    }, [])

    useEffect(() => {
        onHandlerAuth();
    }, [isAuthenticated]);

    const ButtonCardPayment = () => {
        return <span><CreditCardOutlined /> <span className={"pl-4"}>Оплатить картой</span></span>
    }

    const ButtonBankPayment = () => {
        return <span><BankOutlined /> <span className={"pl-4"}>Оплатить по счету</span></span>
    }

    return <div className="min-h-100vh flex grow bg-slate-50 dark:bg-navy-900">
        {contextHolder}
        <main className="grid w-full grow grid-cols-1 place-items-center">
            <div className="w-full max-w-[26rem] p-4 sm:px-5">
                <div className="text-center">
                    <div className="mt-4">
                        <h2 className="text-2xl font-semibold text-slate-600 dark:text-navy-100 p-4">
                            Оформление покупки: <br/>{contentPrice} руб.
                        </h2>
                        <p className="text-slate-400 text-left dark:text-navy-300">
                            {contentTitle}
                        </p>
                    </div>
                </div>
                <div className="card mt-5 rounded-lg p-5 lg:p-7">
                    { !isSendCode && !isUserRegister &&
                        <div>
                            <label className="block">
                                <span>Фамилия: *</span>
                                <span className="relative mt-1.5 flex">
                                <input
                                    className={`form-input peer w-full rounded-lg border border-${isErrorSurname ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                                    placeholder=""
                                    type="text"
                                    onChange={(e) => setValueSurname(e.target.value)}
                                    value={valueSurname}
                                />
                                <span className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                                    <UserIcon/>
                                </span>
                            </span>
                            </label>
                            <label className="block mt-4">
                                <span>Ваше имя: *</span>
                                <span className="relative mt-1.5 flex">
                                <input
                                    className={`form-input peer w-full rounded-lg border border-${isErrorName ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                                    placeholder=""
                                    type="text"
                                    onChange={(e) => setValueName(e.target.value)}
                                    value={valueName}
                                />
                                <span className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                                    <UserIcon/>
                                </span>
                            </span>
                            </label>
                            <label className="block mt-4">
                                <span>Отчество: *</span>
                                <span className="relative mt-1.5 flex">
                                <input
                                    className={`form-input peer w-full rounded-lg border border-${isErrorFatherName ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                                    placeholder=""
                                    type="text"
                                    onChange={(e) => setValueFatherName(e.target.value)}
                                    value={valueFatherName}
                                />
                                <span className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                                    <UserIcon/>
                                </span>
                            </span>
                            </label>
                        <label className="block mt-4">
                            <span>Номер телефона: *</span>
                            <span className="relative mt-1.5 flex">
                                <input
                                    className={`form-input peer w-full rounded-lg border border-${isErrorLogin ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                                    placeholder=""
                                    type="text"
                                    onChange={handleChangeLogin}
                                    value={valueLogin}
                                />
                                <span className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                                    <PhoneIcon/>
                                </span>
                            </span>
                        </label>
                        <label className="block mt-4">
                            <span>E-mail: *</span>
                            <span className="relative mt-1.5 flex">
                                <input
                                    className={`form-input peer w-full rounded-lg border border-${isErrorEmail ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                                    placeholder=""
                                    type="text"
                                    onChange={(e) => setValueEmail(e.target.value)}
                                    value={valueEmail}
                                />
                                <span className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                                    <EmailIcon/>
                                </span>
                            </span>
                        </label>
                        <button onClick={register} className="btn mt-5 w-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                            Далее
                        </button>
                    </div>
                    }
                    {
                        isSendCode && !isUserRegister &&
                        <div>
                            <label className="mt-4 block">
                                <span>Код подтверждения:</span>
                                <span className="relative mt-1.5 flex">
                                    <input
                                           className={`form-input peer w-full rounded-lg border border-${isErrorVerifyCode ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                                           placeholder="Введите код из SMS или E-mail"
                                           type="text"
                                           onChange={(e) => setValueVerifyCode(e.target.value)}
                                           value={valueVerifyCode}
                                    />
                                <span className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5 transition-colors duration-200"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1.5"
                                            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                                    </svg>
                            </span>
                                </span>
                            </label>
                            <button onClick={verify} className="btn mt-5 w-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                                Подтвердить
                            </button>
                        </div>
                    }
                    {
                        isSelectPayment && !isFormCompany &&
                        <div>
                            <div className={"pb-3"}>
                                <Button type={"primary"} onClick={onBuy} text={<ButtonCardPayment/>}/>
                            </div>
                            <Button type={"primary"} onClick={() => setIsFormCompany(true)} text={<ButtonBankPayment/>}/>
                            <div className="mt-3">
                                <Button onClick={() => navigate('/cabinet/catalog/')} text={"<- Вернуться в каталог"} type={"default"}/>
                            </div>
                        </div>
                    }
                    {
                        isFormCompany &&
                        <div>
                            <label className="mt-4 block">
                                <span className={"block pb-2"}>Название компании: *</span>
                                <Input isInvalid={isErrorCompany} type={"text"} value={valueCompany} placeholder={'Введите название компании'} onChange={(value) => setValueCompany(value)}/>
                            </label>
                            <label className="mt-4 block">
                                <span className={"block pb-2"}>ИНН компании: *</span>
                                <Input isInvalid={isErrorCompanyInn} type={"text"} value={valueCompanyInn} placeholder={'Введите ИНН компании'} onChange={(value) => setValueCompanyInn(value)}/>
                            </label>
                            <div className="mt-6">
                                <Button text={"Получить счет"} type={"primary"} onClick={onBuyInvoice}/>
                            </div>
                            <div className="mt-3">
                                <Button onClick={() => setIsFormCompany(false)} text={"<- Выбрать другой способ"} type={"default"}/>
                            </div>
                        </div>
                    }
                </div>

            </div>
        </main>
    </div>

}

export default PublicOrder;
